module.exports = __webpack_public_path__ + "img/glamping_1.b0d29f90.jpg";